import {
  DeviceRegistryCommandFunctionType,
  DeviceRegistryCommandKey
} from '@tryiris-ai/common.protojs/api/v1/device_settings';
import { focus } from './focus.js';
import type { Near } from './types.js';

/**
 * Focus near.
 *
 * @param deviceId - Device ID.
 * @returns A promise that resolves when the command has been processed.
 */
export const near: Near = async (deviceId) =>
  focus(deviceId, [
    DeviceRegistryCommandKey.FOCUS_ABSOLUTE,
    DeviceRegistryCommandFunctionType.DOWN
  ]);
